import ValidationInterface from '@/plans/common/validation-interface';
import {
  eventsUnlimitedCategory,
  eventsPPACategory,
  sessionsUnlimitedCategory,
  sessionsPPACategory,
} from '@/common/persist-cart/categories';
import { EVENT_SAAS_ADDITIONAL_CO_EDITOR, EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR } from '@/common/constants';

export default class extends ValidationInterface {
  async requires() {
    return [
      this.current([EVENT_SAAS_ADDITIONAL_CO_EDITOR]).require([...eventsUnlimitedCategory, ...eventsPPACategory]),
      this.current([EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]).require([
        ...sessionsUnlimitedCategory,
        ...sessionsPPACategory,
      ]),
    ];
  }

  async conflicts() {
    return [
      ...this.current([EVENT_SAAS_ADDITIONAL_CO_EDITOR]).conflict([EVENT_SAAS_ADDITIONAL_CO_EDITOR]),
      ...this.current([EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]).conflict([EVENT_SAAS_CORE_ADDITIONAL_CO_EDITOR]),
    ];
  }
}
